<template>
  <div class="row">
    <div v-bind:class="propColunas">
      <div
        v-if="mensagem !== ''"
        class="alert alert-success alert-dismissible fade show"
        role="alert"
      >
        <strong>{{ mensagem }}</strong>
      </div>
      <Dialog
        :id="uniqueid"
        titulo="Plano Cliente"
        ref="dialog"
        :modal="propView == 'modal'"
        :hideHeader="true"
        :hideFooter="$props.propHideFooter"
      >
        <div class="">
          <div class="row">
            <div class="col-sm-12">
              <div class="form-group row">
                <div class="col-sm-12">
                  <p class="text-center" style="margin-bottom: 5px">
                    Selecione o plano a ser lançado
                  </p>
                  <Combo :itens="planos" v-model="item.plano" />
                  <p v-if="itemErros.plano.status" style="margin-bottom: 0px">
                    <small class="text-danger">{{
                      itemErros.plano.mensagem
                    }}</small>
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div class="row" style="">
            <div class="col-md-12 col-sm-12 text-center">
              <p class="text-center" style="margin-bottom: 5px">Data inicial</p>
              <div class="d-flex justify-content-center">
                <input
                  class="form-control"
                  type="date"
                  v-model="item.dataInicio"
                  style="max-width: 180px"
                />
              </div>
            </div>
          </div>

          <div class="row" style="margin-top: 20px">
            <div class="col-md-12 col-sm-12 text-center">
              <p v-if="item.plano !== '' && !itemErros.dataInicio.status">
                <small v-if="validarDataInicio"
                  >O período do novo plano será do dia
                  {{ formatDate(item.dataInicio) }} á
                  {{
                    formatDate(
                      dateAddDays(
                        item.dataInicio,
                        planosKey[item.plano].duracao
                      )
                    )
                  }}</small
                >
                <small v-if="!validarDataInicio" class="text-danger"
                  >Selecione um período válido</small
                >
              </p>

              <p v-if="itemErros.dataInicio.status">
                <small class="text-danger">{{
                  itemErros.dataInicio.mensagem
                }}</small>
              </p>
            </div>
          </div>

          <div
            class="row"
            v-bind:style="{
              display:
                planosKey &&
                planosKey[item.plano] &&
                planosKey[item.plano].tipo == 'assinante' &&
                retornaSite() !== '7live'
                  ? ''
                  : 'none',
            }"
          >
            <div class="col-md-12 col-sm-12 text-center">
              <p class="text-center" style="margin-bottom: 5px">Comprovante</p>
              <div class="d-flex justify-content-center">
                <Combo
                  :itens="$global.comprovantes()"
                  v-model="item.comprovante"
                />
              </div>
              <p v-if="itemErros.comprovante.status">
                <small class="text-danger">{{
                  itemErros.comprovante.mensagem
                }}</small>
              </p>
            </div>
          </div>

          <div
            class="row"
            style="margin-top: 10px"
            v-bind:style="{
              display:
                planosKey &&
                planosKey[item.plano] &&
                planosKey[item.plano].tipo == 'assinante' &&
                retornaSite() !== '7live'
                  ? ''
                  : 'none',
            }"
          >
            <div class="col-md-12 col-sm-12">
              <p class="text-center" style="margin-bottom: 5px">Indicacao</p>
              <div
                v-bind:style="{ display: item.indicacao == '' ? '' : 'none' }"
              >
                <autocomplete
                  default-value=""
                  :search="filtroIndicacao"
                  :get-result-value="displayFiltroIndicacao"
                  @submit="selecionarFiltroIndicacao"
                  style="width: 100%"
                ></autocomplete>
              </div>
              <div
                v-bind:style="{ display: item.indicacao !== '' ? '' : 'none' }"
              >
                <p
                  class="text-center"
                  style="
                    color: blue;
                    text-decoration: underline;
                    cursor: pointer;
                  "
                  @click="removerFiltroIndicacao()"
                >
                  {{ item.indicacaoEmail }}
                </p>
              </div>
            </div>
          </div>
        </div>

        <template v-slot:rodape>
          <div class="row">
            <div
              class="col-md-12 col-sm-12 d-flex justify-content-center text-center"
            >
              <button
                type="button"
                class="btn btn-secondary"
                v-if="view == 'modal'"
                @click="fechar()"
              >
                Cancelar
              </button>
              <button
                type="button"
                class="btn btn-primary"
                style="margin-left: 10px"
                @click="salvar()"
              >
                Salvar plano
              </button>
            </div>
          </div>
        </template>
      </Dialog>
    </div>
  </div>
</template>

<script>
import { api } from "@/services/api.js";
import util from "../includes/util.js";

import Dialog from "../components/Dialog.vue";
import Combo from "../components/Combo.vue";

import Autocomplete from "@trevoreyre/autocomplete-vue";
import "@trevoreyre/autocomplete-vue/dist/style.css";

export default {
  name: "EditPlanoCliente",
  components: { Dialog, Combo, Autocomplete },
  props: {
    propView: { type: String, default: "modal" },
    propUsuario: { type: String, default: "" },
    propHideFooter: { type: Boolean, default: false },
    propColunas: {
      type: Array,
      default: function () {
        return ["col-md-12"];
      },
    },
  },
  methods: {
    retornaSite() {
      return this.$site;
    },
    async carregarItem(paramUsuario = null, param = {}) {
      //* Limpa os dados
      this.itemErros = util.errosLimpar(this.itemErros);
      this.item.dataInicio = util.dateToStringUS(new Date());
      this.item.usuario = "";
      this.item.plano = "";
      this.item.indicacao = "";
      this.item.indicacaoEmail = "";
      this.item.comprovante = param.comprovante ? param.comprovante : "";
      this.item.pp = param.pp ? param.pp : "";
      this.planos = [];
      this.mensagem = "";

      paramUsuario = paramUsuario == null ? this.propUsuario : paramUsuario;

      if (paramUsuario !== null) {

        //* Armazena o id
        this.item.usuario = paramUsuario;

        const responseUsuario = await api.get(
          "/plano/usuario/" + paramUsuario
        );
        api.valid(responseUsuario.data, this.$router);

        if (!responseUsuario.data.erro) {
        
          if (responseUsuario.data.itens.length > 0) {

            //* Define a data do proximo plano
            this.item.dataInicio = util.dateToStringUS(
              this.dateAddDays(responseUsuario.data.itens[0].dataFim, 1)
            );

            //* Verifica se a data atual maior que a data do ultimo plano
            if (
              util.dateDiffDays(
                new Date(),
                util.parseDateUS(responseUsuario.data.itens[0].dataFim)
              ) < 0
            ) {
              this.item.dataInicio = util.dateToStringUS(new Date());
            }
          }

          //* Verifica se deve definir a indicacao
          if (
            responseUsuario.data.indicacao &&
            responseUsuario.data.indicacao._id &&
            responseUsuario.data.indicacao.email
          ) {
            this.item.indicacao = responseUsuario.data.indicacao._id
              ? responseUsuario.data.indicacao._id
              : "";
            this.item.indicacaoEmail = responseUsuario.data.indicacao.email
              ? responseUsuario.data.indicacao.email
              : "";
          }

          //const response = await api.get("/plano?site=");
          //api.valid(response.data, this.$router);

          //* Percorre todos os planos
          for (
            var indicePlano = 0;
            indicePlano < responseUsuario.data.novosPlanos.length;
            indicePlano++
          ) {
            var plano = responseUsuario.data.novosPlanos[indicePlano];

            if (indicePlano == 0) {
              this.item.plano = plano._id;
            }

            this.planos.push({
              id: plano._id,
              nome: plano.nome + " (" + plano.duracao + " dias)",
              plano: plano,
            });

            this.planosKey[plano._id] = plano;
          }
        }
      }
    },
    async salvar() {
      this.itemErros = util.errosLimpar(this.itemErros);

      //* Verifica se o usuario foi definido
      if (this.item.usuario !== "") {
        //* Envia os dados para a api
        var apiRequest = await api.post("/plano/usuario", {
          usuario: this.item.usuario,
          plano: this.item.plano,
          dataInicio: this.item.dataInicio,
          comprovante: this.item.comprovante,
          pp: this.item.pp,
          indicacao:
            this.planosKey[this.item.plano].tipo == "assinante"
              ? this.item.indicacao
              : "",
        });

        //* Verifica se ocorreu algum erro
        if (!apiRequest.data.erro) {

          if(this.$props.propView == 'document')
          {
            this.$emit("salvou", {});
          }else{
            //* Fecha a janela
            this.$refs.dialog.fechar();
            this.$emit("fechar", this.item);
          }

        } else {

          this.$emit("erro", {});

          if (apiRequest.data.erros) 
          {
            util.errosProcessar(this.itemErros, apiRequest.data.erros);
          }
        }
      }
    },
    async novo() {

      /*this.$set(this.item, "usuario", "");
      this.$set(this.item, "plano", "");
      this.$set(this.item, "dataInicio", "");
      this.$set(this.item, "comprovante", "");
      
      this.$set(this.item, "indicacao", "");
      this.$set(this.item, "indicacaoEmail", "");
      this.itemErros = util.errosLimpar(this.itemErros);*/

    },
    async enterSalvar(event) {
      if (event.keyCode === 13) {
        event.preventDefault();
        this.salvarItem();
      }
    },
    fechar() {
      this.$refs.dialog.fechar();
      this.$emit("fechar");
    },
    abrir() {
      this.$refs.dialog.abrir();
      this.carregarItem();
    },
    formatDate(data) {
      if (data == "-") {
        return data;
      }
      return util.formatDate(data);
    },
    dateAddDays(data, days) {
      var date = new Date(data.valueOf());
      date.setDate(date.getDate() + days);
      return date;
    },
    selecionarFiltroIndicacao(result) {
      this.item.indicacaoEmail = result.email;
      this.item.indicacao = result._id;
    },
    removerFiltroIndicacao() {
      this.item.indicacao = "";
      this.item.indicacaoEmail = "";
    },
    filtroIndicacao(input) {
      if (this.planos.length == 0) {
        return [];
      }

      var filtros = "?_limit=10&_page=1";

      if (input !== "") {
        filtros += "&_all=" + input;
      }

      filtros += "&site=" + this.planos[0].plano.site;

      return new Promise((resolve) => {
        if (input.length < 3) {
          return resolve([]);
        }

        api.get("/usuario" + filtros).then((response) => {
          if (!response.data.erro) {
            resolve(response.data.itens);
          }
        });
      });
    },
  },
  async mounted() {
    this.view = this.propView;
    this.uniqueid = 'dialogEditPlanoCliente_' + util.guidGenerator();
  },
  data: function () {
    return {
      uniqueid: "",
      item: {
        usuario: "",
        plano: "",
        dataInicio: "",
        comprovante: "",
        indicacao: "",
        indicacaoEmail: "",
        pp: ""
      },
      itemErros: {
        plano: { status: false, mensagem: "" },
        dataInicio: { status: false, mensagem: "" },
        comprovante: { status: false, mensagem: "" },
      },
      view: "",
      mensagem: "",
      planos: [],
      planosKey: {},
      displayFiltroIndicacao(result) {
        return result.email;
      },
    };
  },
  computed: {
    validarDataInicio: function () {
      var dataInicio = util.parseDateUS(this.item.dataInicio);

      if (util.dateDiffDays(new Date(), dataInicio) >= 0) {
        return true;
      } else {
        return false;
      }
    },
  },
};
</script>

<style></style>
